export default __webpack_public_path__ + "static/media/aboutus.d19100ab.gif";